export enum OLRVersion {
  Sidedoor = 'sidedoor',
  SidedoorAmdea = 'sidedoor-amdea',
  SidedoorPromo = 'sidedoor-promo',
  SidedoorSDA = 'sidedoor-sda',
  SidedoorROI = 'sidedoor-roi',
}
